import {
  FileAudio,
  FileImage,
  FileText,
  FileVideo,
  File as FileIcon,
  type LucideIcon,
} from "lucide-react";

import type { FileType } from "./types";

/**
 * Per-file-type icon + colour pair. Used by the library table, the
 * dashboard recent list, and anywhere else we render a doc inline.
 * Colours stay subtle — they're meant to scan, not shout.
 */
export const FILE_TYPE_STYLES: Record<FileType, {
  icon: LucideIcon;
  /** Tailwind colour class for the icon stroke. */
  iconClass: string;
  /** Tailwind tone for the soft chip background. */
  chipClass: string;
}> = {
  document: { icon: FileText,  iconClass: "text-blue-600",   chipClass: "bg-blue-50 dark:bg-blue-500/15 text-blue-700 dark:text-blue-300" },
  video:    { icon: FileVideo, iconClass: "text-rose-600",   chipClass: "bg-rose-50 dark:bg-rose-500/15 text-rose-700 dark:text-rose-300" },
  audio:    { icon: FileAudio, iconClass: "text-violet-600", chipClass: "bg-violet-50 text-violet-700 dark:text-violet-300" },
  image:    { icon: FileImage, iconClass: "text-emerald-600",chipClass: "bg-emerald-50 dark:bg-emerald-500/15 text-emerald-700 dark:text-emerald-300" },
  other:    { icon: FileIcon,  iconClass: "text-muted-foreground",  chipClass: "bg-muted text-foreground/80" },
};
